<div>
  <div class="d-flex justify-content-center align-items-center header-legals">
    <img src="./assets/logo2.png" alt="Logo" class="logo-legals">
  </div>
  <div class="text-legals">
    <div [innerHTML]="sanitizedText"></div>
    @if (loadingData) {
      <mat-spinner [diameter]='50' class='spinner-legals'></mat-spinner>
    }
  </div>
</div>
